/**
 *    vue-loading-overlayについて
 *    https://github.com/ankurk91/vue-loading-overlay
 * 
 * 	- 使い方
 * 		import { storeAccessor } from './store/storeAccessor';
 * 
 * 		ローディング開始
 * 		storeAccessor.setIsLoading(true);
 * 		ローディング終了
 * 		storeAccessor.setIsLoading(false);
 * 
 * 	- App.vueにローディングコンポーネント配置
 * 		storeに定義しているisLoadingフラグにより表示、非表示を切り替える。
 * 
 * - 2021/03/24 共通に使用しているaxiosを修正し、
 *   リクエスト時に自動ローディング、レスポンス(エラー含む)時にローディングを自動解除するようにしました。
 */
//import Vue from 'vue'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

// TODO 色指定が効いていない
//Vue.use(Loading, {
//  color: '#0275d8'
//});

// グローバル登録
//Vue.component('loading', Loading);

export default (app) => {
  app.component('loadingOverlay', Loading);
}